import Link from "next/link";

// import logoImagePC from "/public/assets/pc/logo.svg";
import styles from "./헤더_Desktop2.module.css";

import { 헤더_회원가입_Desktop2 } from "./헤더_회원가입_Desktop2";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";
import { 마켓봄_로고_Desktop } from "./마켓봄_로고_Desktop";

import { asx } from "./util/applyStyle";
import { useContext } from "react";
import { GrowthBookCTX, getValue } from "./util/GrowthBookCTX";
import { pipe } from "@mobily/ts-belt";
import { 무료체험기간 } from "./데이터/무료체험기간";

const as = asx(styles);

export const 헤더_Desktop3 = () => {
  const tracker = useTracker();
  const featureFlag = useContext(GrowthBookCTX);
  const simplifiedRegister = pipe(featureFlag, getValue("simplified-register"));

  return (
    <div className={as("header docked")}>
      <div className={styles["content"]}>
        <div className={styles["contentLeft"]}>
          <마켓봄_로고_Desktop />
          <div className={styles["gnb"]}>
            <ul className={styles["naviagtionRow"]}>
              <li>
                <span className={styles["link"]}>서비스 소개</span>
                <div className={styles["depth2"]}>
                  <ul>
                    <li>
                      <Link
                        href={링크.마켓봄_자세히보기}
                        onClick={() =>
                          tracker.trackingClick({
                            depth1: "GNB",
                            depth2: "소개",
                            depth3: "마켓봄",
                          })
                        }
                      >
                        마켓봄
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={링크.마켓봄도매_자세히보기}
                        onClick={() =>
                          tracker.trackingClick({
                            depth1: "GNB",
                            depth2: "소개",
                            depth3: "마켓봄 도매",
                          })
                        }
                      >
                        마켓봄 도매
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <Link
                  href={링크.마켓봄_이용가이드}
                  className={styles["link"]}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "GNB",
                      depth2: "이용가이드",
                    })
                  }
                >
                  이용가이드
                </Link>
              </li>
              <li>
                <Link
                  href={링크.비대면바우처}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "GNB",
                      depth2: "비대면바우처",
                    })
                  }
                  className={styles["link"]}
                >
                  비대면바우처
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles["sign-area"]}>
          <div className={styles["signButtons"]}>
            <div className={styles["signInButton"]}>
              로그인
              <div className={styles["loginDetail"]}>
                <Link
                  href={링크.마켓봄_통합로그인}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "GNB",
                      depth2: "로그인",
                      depth3: "유통사",
                    })
                  }
                >
                  유통사/매입처
                </Link>
                <Link
                  href={링크.마켓봄_거래처}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "GNB",
                      depth2: "로그인",
                      depth3: "식당",
                    })
                  }
                >
                  거래처(식당)
                </Link>
              </div>
            </div>
            <헤더_회원가입_Desktop2 />

            <Link
              className={styles["signUpButton"]}
              href={
                simplifiedRegister
                  ? 링크.마켓봄_간편가입_실험_링크_PC
                  : 링크.마켓봄_회원가입
              }
              onClick={() =>
                tracker.trackingClick({
                  depth1: "GNB",
                  depth2: "회원가입",
                  depth3: "마켓봄",
                  indicator: "회원가입",
                  scroll: window.scrollY,
                })
              }
            >
              <div className={as("overlay")} />
              <div className={as("signUpCatchPhrase")}>
                <span>{`${무료체험기간.마켓봄} 무료 체험`}</span>
                <span>{"5초 만에 시작하기"}</span>
                <span>{`${무료체험기간.마켓봄} 무료 체험`}</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
